import { Fetch } from '../fetch/fetch-service';

export function fetchProfile() {
  return Fetch('/idp-auth/pbasen/personinfo');
}

export function fetchAddSelfPolitician(politician = {}) {
  return Fetch('/idp-auth/pbasen/register', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(politician),
  });
}

export function fetchRole() {
  return Fetch('/idp-auth/pbasen/getProfile');
}

export function doVerify() {
  Fetch('/idp-auth/pbasen/getVerifyUser', {
    method: 'GET',
  });
}
